import { REPORT_ANALYTICS_API } from 'constants/AppConstants';

export default async (queryParams, orgId) => {
  try {
    const response = await fetch(`${REPORT_ANALYTICS_API.replace(':orgId', orgId)}?${queryParams}`);
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
